import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import Person from "static/icons/face_black_24dp.svg"

const ModulePersonIcon = (props: IconWrapperIconProps) => {
  const name = "modulePerson"
  return (
    <IconWrapper name={name} {...props}>
      <Person/>
    </IconWrapper>
  )
}

export default ModulePersonIcon
